"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
function onLoad(callback) {
  $('body').ready(callback);
}
exports.onLoad = onLoad;
function onClick(selector, callback) {
  $('body').on('click', selector, callback);
}
exports.onClick = onClick;
function onChange(selector, callback, stopPropagation) {
  if (stopPropagation === void 0) {
    stopPropagation = false;
  }
  if (stopPropagation) {
    $('body').on('change', selector, function (e) {
      e.stopPropagation();
      callback;
    });
  } else {
    $('body').on('change', selector, callback);
  }
}
exports.onChange = onChange;
function onBlur(selector, callback) {
  $('body').on('blur', selector, callback);
  console.warn('onBlur hook detected. Please, do not use that because it my cause Event Bubbling. Use onFocusOut instead');
}
exports.onBlur = onBlur;
function onDoubleClick(selector, callback) {
  $('body').on('dblclick', selector, callback);
}
exports.onDoubleClick = onDoubleClick;
function onMouseEnter(selector, callback) {
  $('body').on('mouseenter', selector, callback);
}
exports.onMouseEnter = onMouseEnter;
function onMouseLeave(selector, callback) {
  $('body').on('mouseleave', selector, callback);
}
exports.onMouseLeave = onMouseLeave;
function onMouseDown(selector, callback) {
  $('body').on('mousedown', selector, callback);
}
exports.onMouseDown = onMouseDown;
function onMouseUp(selector, callback) {
  $('body').on('mouseup', selector, callback);
}
exports.onMouseUp = onMouseUp;
function onHover(selector, callback) {
  $('body').on('hover', selector, callback);
}
exports.onHover = onHover;
function onKeyDown(selector, callback) {
  $('body').on('keydown', selector, callback);
}
exports.onKeyDown = onKeyDown;
function onKeyUp(selector, callback) {
  $('body').on('keyup', selector, callback);
}
exports.onKeyUp = onKeyUp;
function onKeyPress(selector, callback) {
  $('body').on('keypress', selector, callback);
}
exports.onKeyPress = onKeyPress;
function onFocus(selector, callback) {
  $('body').on('focus', selector, callback);
}
exports.onFocus = onFocus;
function onFocusOut(selector, callback) {
  $('body').on('focusout', selector, callback);
}
exports.onFocusOut = onFocusOut;
function onSubmit(selector, callback) {
  $('body').on('submit', selector, callback);
}
exports.onSubmit = onSubmit;
function onResize(callback) {
  $('body').on('resize', callback);
}
exports.onResize = onResize;
function on(event, callback, selector, data) {
  $('body').on("" + event, selector, callback);
}
exports.on = on;
function onWindowEvent(event, callback, selector, data) {
  $(window).on("" + event, selector, callback);
}
exports.onWindowEvent = onWindowEvent;